<template>
	<div class="add-form">
		<Form ref="addForm" :model="form" :rules="diyData.rules" :label-width="100">
			<FormItem label="前端链接" prop="url">
				<Input v-model="form.url" placeholder="请输入前端链接" style="width: 440px"></Input>
			</FormItem>
			<FormItem label="真实前端链接" prop="real_url">
				<Input v-model="form.real_url" placeholder="请输入真实前端链接" style="width: 440px"></Input>
			</FormItem>
      <FormItem label="支付域名" prop="pay_url">
				<Input v-model="form.pay_url" placeholder="请输入支付域名" style="width: 440px"></Input>
			</FormItem>
      <FormItem label="落地页地址" prop="real_visit_url">
				<Input v-model="form.real_visit_url" placeholder="请输入落地页地址" style="width: 440px"></Input>
			</FormItem>
		</Form>
		<Button type="primary" style="width: 90px; margin-right: 20px" @click="submit">保存</Button>
	</div>
</template>

<script>
	import uploadFileOne from '@/components/upload-custom/upload-file-one'
	import { apiGetSystem, apiSetSystem } from '@/api/system'

	export default {
		name: 'add-form',
		components: {
			uploadFileOne,
		},
		data() {
			return {
				query: {},
				search: {},
				diyDom: {},
				// 表单数据
				form: {
					url: '',
					real_url: '',
          pay_url:"",
          real_visit_url:""
				},
				diyData: {
					rules: {
						url: [{ required: true, message: '请输入前端链接', trigger: 'blur' }],
						real_url: [{ required: true, message: '请输入真实前端链接', trigger: 'blur' }],
						pay_url: [{ required: true, message: '请输入支付域名', trigger: 'blur' }],
						real_visit_url: [{ required: true, message: '请输入落地页地址', trigger: 'blur' }],
					},
				},
				apiData: {},
			}
		},
		computed: {},
		methods: {
			// 获取配置
			getSettings() {
				this.$store.commit('setSpinShow', true)
				apiGetSystem('web_url')
					.then(res => {
						this.form.url = res.url
						this.form.real_url = res.real_url
						this.form.pay_url = res.pay_url
            this.form.real_visit_url = res.real_visit_url
					})
					.finally(() => this.$store.commit('setSpinShow', false))
			},

			// 获取上传的图片
			fileChange(e, type) {
				if (type == 'show_image') {
					this.form.show_image = e
				} else if (type == 'big_image') {
					this.form.big_image = e
				}
			},
			submit() {
				this.$refs['addForm'].validate(valid => {
					if (valid) {
						apiSetSystem('web_url', {
							web_url: this.form,
						}).then(() => {
							this.$Message.success('保存成功')
							this.getSettings()
						})
					}
				})
			},
		},
		mounted() {
			this.getSettings()
		},
	}
</script>

<style scoped lang="less">
	.add-form {
		border: 1px solid #ededed;
		margin: 0 20px;
		padding: 26px 20px;

		.title {
			font-size: 14px;
			font-weight: bold;
			color: #333333;
			line-height: 19px;
			margin-bottom: 10px;
		}
	}
</style>
